import React, { useState, useEffect } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import EmailAddress from "./EmailAddress";
import "./Navbar.css";

const Navbar = () => {
  const [scrolled, setScrolled] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const goToOffer = () => {
    setMobileMenuOpen(false);
    if (location.pathname !== "/") {
      navigate("/#kontakt");
      return;
    }
    document.getElementById("kontakt")?.scrollIntoView({ behavior: "smooth" });
  };

  const toggleMobileMenu = () => {
    setMobileMenuOpen(!mobileMenuOpen);
  };

  const goToTop = (event) => {
    setMobileMenuOpen(false);
    if (location.pathname !== "/") return;
    event.preventDefault();
    if (location.hash || location.search) {
      navigate("/", { replace: true });
    }
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  const handleMobileLinkClick = () => {
    setMobileMenuOpen(false);
  };

  return (
    <nav className={`navbar ${scrolled ? 'scrolled' : ''} ${mobileMenuOpen ? 'mobile-menu-open' : ''}`} role="navigation" aria-label="Hauptnavigation">
      {/* Mobile: Shown when scrolled - Logo + Hamburger */}
      <div className="navbar-top">
        <Link to="/" className="logo-container" onClick={goToTop}>
          <img 
            src="/mfdlogo.png" 
            alt="M.F.D. & CO Gebäudereinigung Logo - Professionelle Reinigungsservices in Berlin" 
            className="logo-img"
            width="100"
            height="100"
            loading="eager"
          />
          <div className="logo-text">
            <strong>M.F.D. & Co.</strong>
            <br />
            DIENSTLEISTUNGEN
          </div>
        </Link>

        <button
          className="hamburger-btn"
          onClick={toggleMobileMenu}
          aria-label="Menü öffnen/schließen"
          aria-expanded={mobileMenuOpen}
        >
          <span className={`hamburger-line ${mobileMenuOpen ? 'open' : ''}`}></span>
          <span className={`hamburger-line ${mobileMenuOpen ? 'open' : ''}`}></span>
          <span className={`hamburger-line ${mobileMenuOpen ? 'open' : ''}`}></span>
        </button>
      </div>

      {/* Desktop: Always shown, Mobile: Shown when NOT scrolled */}
      <Link to="/" className="logo-container main-logo" onClick={goToTop}>
        <img 
          src="/mfdlogo.png" 
          alt="M.F.D. & CO Gebäudereinigung Logo - Professionelle Reinigungsservices in Berlin" 
          className="logo-img"
          width="100"
          height="100"
          loading="eager"
        />
        <div className="logo-text">
          <strong>M.F.D. & Co.</strong>
          <br />
          DIENSTLEISTUNGEN
        </div>
      </Link>

      <div className={`contact ${scrolled ? 'hide-on-scroll' : ''}`}>
        <div className="phone-numbers">
          <a href="tel:+4915143148300" aria-label="Rufen Sie uns an: +49 151 431 48300" onClick={handleMobileLinkClick}>
            <span className="phone-icon">📞</span>
            +49 151 431 48300
          </a>
          <a href="tel:+491705046545" aria-label="Rufen Sie uns an: +49 170 504 6545" onClick={handleMobileLinkClick}>
            <span className="phone-icon">📞</span>
            +49 170 504 6545
          </a>
        </div>
        <div className="email-contact">
          <span className="email-icon">✉️</span>
          <a href="mailto:mfdienstleistungen@hotmail.com" aria-label="Senden Sie uns eine E-Mail" onClick={handleMobileLinkClick}>
            <EmailAddress email="mfdienstleistungen@hotmail.com" />
          </a>
        </div>
      </div>

      <button
        className={`angebot-btn ${scrolled ? 'hide-on-scroll' : ''}`}
        onClick={goToOffer}
        aria-label="Angebot anfordern - Springe zum Kontaktbereich"
      >
        Angebot Anfordern
      </button>

      {/* Mobile Menu Dropdown - Shown when hamburger is clicked */}
      <div className={`mobile-menu ${mobileMenuOpen ? 'open' : ''}`}>
        <div className="mobile-menu-content">
          <div className="phone-numbers">
            <a href="tel:+4915143148300" aria-label="Rufen Sie uns an: +49 151 431 48300" onClick={handleMobileLinkClick}>
              <span className="phone-icon">📞</span>
              +49 151 431 48300
            </a>
            <a href="tel:+491705046545" aria-label="Rufen Sie uns an: +49 170 504 6545" onClick={handleMobileLinkClick}>
              <span className="phone-icon">📞</span>
              +49 170 504 6545
            </a>
          </div>
          <div className="email-contact">
            <span className="email-icon">✉️</span>
            <a href="mailto:mfdienstleistungen@hotmail.com" aria-label="Senden Sie uns eine E-Mail" onClick={handleMobileLinkClick}>
              <EmailAddress email="mfdienstleistungen@hotmail.com" />
            </a>
          </div>
          <button
            className="angebot-btn mobile"
            onClick={goToOffer}
            aria-label="Angebot anfordern - Springe zum Kontaktbereich"
          >
            Angebot Anfordern
          </button>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
